import { JiraField } from 'api/integrations';

export const defaultRows = [
  {
    fieldName: 'Issue Type',
    fieldType: 'SINGLE_SELECT',
    fieldDataType: 'TEXT',
    customField: false,
    fieldLabel: 'Issue Type',
    integrationFieldId: 'issuetype',
    required: true,
    optionsAvailable: true,
  },
  {
    fieldName: 'Summary',
    fieldType: 'SINGLE_SELECT',
    fieldDataType: 'TEXT',
    customField: false,
    fieldLabel: 'Summary',
    required: true,
    integrationFieldId: 'summary',
  },
  {
    fieldName: 'Description',
    fieldType: 'SINGLE_SELECT',
    fieldDataType: 'TEXT',
    customField: false,
    fieldLabel: 'Description',
    integrationFieldId: 'description',
  },
] as JiraField[];

export const defaultJiraFieldIds = defaultRows.map(
  (defaultRow) => defaultRow.integrationFieldId,
);
